// 设计方案
export default [
    {
        path: '/design',
        redirect: '/design/group',
    },

    // 专案
    {
        path: '/design/group',
        name: 'design-group',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/group/Index.vue'),
        meta: {title: '专案管理'},
    },
    {
        path: '/design/group/detail/:id',
        name: 'design-group-detail',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/group/detail/Index.vue'),
        meta: {title: '专案管理'},
    },
    {
        path: '/design/group/edit/:id',
        name: 'design-group-edit',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/group/edit/Index.vue'),
        meta: {title: '专案管理'},
    },
    {
        path: '/design/group/restore',
        name: 'design-group-restore',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/group/restore/Index.vue'),
        meta: {title: '专案恢复'},
    },
    {
        path: '/design/group/model/detail/:id',
        name: 'design-group-model',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/group/model/Detail.vue'),
        meta: {title: '专案管理'},
    },
    {
        path: '/design/group/material/detail/:id',
        name: 'design-group-material',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/group/material/Detail.vue'),
        meta: {title: '专案管理'},
    },
    {
        path: '/design/group/log/operate',
        name: 'design-group-log-operate',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/group/log/operate/Index.vue'),
        meta: {title: '专案操作日志'},
    },
    {
        path: '/design/group/log/adjust/:projectGroupId',
        name: 'design-group-log-adjust',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/group/log/adjust/Index.vue'),
        meta: {title: '物料调整日志'},
    },
    // 展示管理
    {
        path: '/design/group/dps',
        name: 'design-group-dps',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/group/dps/Index.vue'),
        meta: {title: '展示管理'},
    },

    // 样板间及数字房型
    {
        path: '/design/blank-room',
        name: 'design-room',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/room/Index.vue'),
        meta: {title: '样板间管理'},
    },
    {
        path: '/design/blank-room/edit/:id',
        name: 'design-room-edit',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/room/edit/Index.vue'),
        meta: {title: '样板间管理'},
    },
    // 样板间展示管理
    {
        path: '/design/blank-room/dps',
        name: 'design-room-dps',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/room/dps/Index.vue'),
        meta: {title: '展示管理'},
    },
    {
        path: '/design/blank-room/clear/list',
        name: 'design-room-clear',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/room/clear/Maps.vue'),
        meta: {title: '地图清理'},
    },
    {
        path: '/design/blank-room/clear/log',
        name: 'design-room-clear-log',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/room/clear/Log.vue'),
        meta: {title: '地图清理日志'},
    },
    {
        path: '/design/digital-room',
        name: 'design-digital-room',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/digital-room/Index.vue'),
        meta: {title: '数字房型'},
    },

    // 愿望单及资源定制
    {
        path: '/design/favorite',
        name: 'design-favorite',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/favorite/Index.vue'),
        meta: {title: '愿望单管理'},
    },
    {
        path: '/design/custom-resource',
        name: 'ue-custom',
        component: () => import(/* webpackChunkName: "design" */ '@/views/ue/custom/Index.vue'),
        meta: {title: '定制资源管理'},
    },

    // 导航及检索
    {
        path: '/design/nav',
        name: 'design-nav',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/nav/Index.vue'),
        meta: {title: '专案导航'},
    },
    {
        path: '/design/search',
        name: 'design-retrieval',
        component: () => import(/* webpackChunkName: "design" */ '@/views/design/retrieval/Index.vue'),
        meta: {title: '专案检索'},
    },
];
